import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

export function Faq() {
  const { t } = useLanding();
  const [open, setOpen] = useState(0);
  return (
    <InteractiveSection className="section" id="faq" data-testid="faq-section">
      <MotionBg variant="ripples" dots={3} />
      <div className="container faq-grid">
        <Reveal>
          <p className="eyebrow"><span className="eyebrow-no">08</span>{t.faq.eyebrow}</p>
          <h2>{t.faq.title}</h2>
          <p className="subhead">{t.faq.lead}</p>
        </Reveal>
        <Reveal className="faq-list" delay={0.1}>
          {t.faq.items.map((item, index) => {
            const isOpen = open === index;
            return (
              <div className={`faq-item ${isOpen ? "open" : ""}`} key={item.q}>
                <button className="faq-question" type="button" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? -1 : index)} data-testid={`faq-question-${index}`}>
                  <span>{item.q}</span>
                  <span className="faq-plus" aria-hidden="true" />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div className="faq-answer" initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.38, ease: [0.2, 0.75, 0.25, 1] }} data-testid={`faq-answer-${index}`}>
                      <p>{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </Reveal>
      </div>
    </InteractiveSection>
  );
}
